module.exports = __webpack_public_path__ + "media/images/wod-logo-small-ddfad5e9.png";